import DynamicProgressBar from './DynamicProgressBar';

import { SRBMDetailData } from 'api/traps/SRBMTraps/types';

interface InfoCardsRowProps {
  data: SRBMDetailData | null;
  isLoading: boolean;
}

const InfoCardsRow: React.FC<InfoCardsRowProps> = ({ data }) => {
  const endNumber =
    data?.eaten_bait_from_last_add && data?.bait_filling
      ? Number(data.eaten_bait_from_last_add) - Math.abs(Number(data.bait_filling))
      : 0;

  const percentage =
    data?.eaten_bait_from_last_add && data?.bait_filling
      ? (Number(data.bait_filling) / Number(data.eaten_bait_from_last_add)) * 100
      : 0;
  return (
    <div className="row d-flex flex-row justify-content-center align-items-center g-3 ">
      <DynamicProgressBar
        percentage={percentage}
        startNumber={data?.eaten_bait_from_last_add || null}
        currentNumber={data?.bait_filling || null}
        endNumber={endNumber}
      />
      {/* <InfoCard
        value={data?.eaten_bait_from_last_add || null}
        text={t('SBSDetail.infoCardsRow.eatenBaitFromLastAdd')}
        icon="text-light ri-hand-coin-fill"
        isLoading={isLoading}
      />
      <InfoCard
        value={data?.bait_filling || null}
        text={t('SBSDetail.infoCardsRow.baitAmountInStation')}
        icon="text-light ri-bubble-chart-fill"
        isLoading={isLoading}
      />
      <InfoCard
        value={data?.recomended_bait_filling || null}
        text={t('SBSDetail.infoCardsRow.recomendedBaitFilling')}
        icon="text-light ri-download-2-fill"
        isLoading={isLoading}
      /> */}
    </div>
  );
};

export default InfoCardsRow;
